__turbopack_context__.v({
  "card": "AllAvailablePrograms-module-scss-module__Nd0tEq__card",
  "cardBody": "AllAvailablePrograms-module-scss-module__Nd0tEq__cardBody",
  "cardDesc": "AllAvailablePrograms-module-scss-module__Nd0tEq__cardDesc",
  "cardDuration": "AllAvailablePrograms-module-scss-module__Nd0tEq__cardDuration",
  "cardTitle": "AllAvailablePrograms-module-scss-module__Nd0tEq__cardTitle",
  "container": "AllAvailablePrograms-module-scss-module__Nd0tEq__container",
  "grid": "AllAvailablePrograms-module-scss-module__Nd0tEq__grid",
  "gridBox": "AllAvailablePrograms-module-scss-module__Nd0tEq__gridBox",
  "headerBox": "AllAvailablePrograms-module-scss-module__Nd0tEq__headerBox",
  "heading": "AllAvailablePrograms-module-scss-module__Nd0tEq__heading",
  "iconBadge": "AllAvailablePrograms-module-scss-module__Nd0tEq__iconBadge",
  "loadMoreBtn": "AllAvailablePrograms-module-scss-module__Nd0tEq__loadMoreBtn",
  "section": "AllAvailablePrograms-module-scss-module__Nd0tEq__section",
  "subtitle": "AllAvailablePrograms-module-scss-module__Nd0tEq__subtitle",
  "viewDetails": "AllAvailablePrograms-module-scss-module__Nd0tEq__viewDetails",
});
